import _defineProperty from "@babel/runtime/helpers/defineProperty";
import $metrics from 'app/stores/metrics/$metrics';
export var FlowMeasurement = /*#__PURE__*/function (FlowMeasurement) {
  FlowMeasurement["FLOW"] = "/kentik/licensing/flow";
  FlowMeasurement["FLOW_PROXY"] = "/kentik/licensing/flow/flowproxy";
  FlowMeasurement["KPROXY"] = "/kentik/licensing/flow/kproxy";
  return FlowMeasurement;
}({});
export function getDeviceFlowMeasurement(device) {
  var _device$get;
  if (!device || !device.get('stats')) {
    console.warn('Device or device stats not defined, defaulting to /flow query measurement');
  }
  var measurement = FlowMeasurement.FLOW; // Default to /flow measurement

  var IsAgent = (_device$get = device.get('stats')) === null || _device$get === void 0 ? void 0 : _device$get.IsAgent;

  // If IsAgent is defined and greater than 0, use flowproxy/kproxy measurements
  if (!!IsAgent && IsAgent > 0) {
    if (device.get('device_kentik_agent_id') && $metrics.measurementModelByName(FlowMeasurement.FLOW_PROXY)) {
      measurement = FlowMeasurement.FLOW_PROXY;
    } else if (!device.get('device_kentik_agent_id') && $metrics.measurementModelByName(FlowMeasurement.KPROXY)) {
      measurement = FlowMeasurement.KPROXY;
    }
  }
  return measurement;
}
export function getFlowQueries(_ref) {
  var dimensions = _ref.dimensions,
    _ref$filters = _ref.filters,
    filters = _ref$filters === void 0 ? [] : _ref$filters,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 100 : _ref$limit,
    lookback = _ref.lookback,
    metric = _ref.metric,
    measurement = _ref.measurement,
    merge = _ref.merge,
    _ref$rollup = _ref.rollup,
    rollup = _ref$rollup === void 0 ? 'avg' : _ref$rollup;
  var query = {
    update_frequency: 0,
    use_kmetrics: true,
    show_overlay: false,
    show_total_overlay: false,
    kmetrics: {
      measurement: measurement,
      dimensions: dimensions,
      metrics: [{
        name: metric,
        type: 'gauge'
      }],
      range: {
        lookback: lookback
      },
      window: {
        size: 0,
        fn: _defineProperty({}, "".concat(metric), 'avg')
      },
      rollups: _defineProperty({}, "".concat(rollup, "_").concat(metric), {
        metric: metric,
        aggregate: "".concat(rollup)
      }),
      sort: [{
        direction: 'desc',
        name: "last_".concat(metric)
      }],
      limit: limit,
      includeTimeseries: 20,
      streamingUpdate: false,
      filters: {
        connector: 'All',
        filterGroups: [{
          name: '',
          named: false,
          connector: 'All',
          not: false,
          filters: filters
        }]
      }
    }
  };
  if (merge) {
    query.kmetrics.merge = merge;
  }
  return query;
}